"use client"

import Image, { StaticImageData, ImageProps } from 'next/image'
import { useState } from 'react'

type Props = {
  fallback: string | StaticImageData
  src: string | StaticImageData
} & Omit<ImageProps, 'src'>

export const LazyImage: React.FC<Props> = ({ fallback, src, ...rest }) => {
  const [imageSrc, setImageSrc] = useState<string | StaticImageData>(src)

  return (
    <Image
      {...rest}
      src={imageSrc}
      onError={() => setImageSrc(fallback)}
      loading='lazy'
      alt={rest.alt || 'Image'}
    />
  )
}
